import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import moment from 'moment/min/moment-with-locales';
import { debounce } from 'lodash';
import {handleTabKey, resizeHandler, smallerImage} from '../../utils';

import {getCookie, formatLocalDate, getLabel} from '../../utils';
import LiveBarHolder from './LiveBarStyles';

const LiveBar = (props) => {
	const { active } = props;
	const liveContainer = useRef(null);
	const modalRef = useRef(null);
	const [delayAnim, setDelayAnim] = useState();

	useEffect(()=> {
		const lang = getCookie("lan");
		
		Moment.globalMoment = moment;

		if(lang === "en") {
			moment.locale("en");
			Moment.globalLocale = 'en';
		} else {
			moment.locale("fr");
			Moment.globalLocale = 'fr';
		}

		window.addEventListener('resize', debounce(function() {
			resizeHandler('.live-container__item');
		},300));

		return ()=> window.removeEventListener('resize',()=>resizeHandler('.live-container__item'));

	},[]);

	useEffect(() => {
		if (props.active) {
			document.addEventListener("keydown", (e) => props.handleEscape(e, props.liveBarClickHandler));
		} else {
			document.removeEventListener("keydown", (e) => props.handleEscape(e, props.liveBarClickHandler));
		}
		setTimeout(() => {
			if (props.active && liveContainer && liveContainer.current) {
				liveContainer.current.focus();
			}
		}, 500);
	}, [props.active]);

	useEffect(() => {
		if( props.active && modalRef.current) {
			const keyListenersMap = props.active ? new Map([[27, props.liveBarClickHandler], [9, (e) => handleTabKey(e, modalRef)]]) : null;
			function keyListener(e) {
				const listener = keyListenersMap.get(e.keyCode);
				return listener && listener(e);
			}

			document.addEventListener("keydown", keyListener);
			setDelayAnim(false);
			resizeHandler('.live-container__item');

			return () => document.removeEventListener("keydown", keyListener);
		} else {
			setTimeout(()=>{
				setDelayAnim(true);
			},500);
		}

	}, [props.active]);

	const renderSmallItemInfo = (item) => {
		const minutesBefore = process.env.REACT_APP_LIVE_NOTIFICATION_TIME;
		const now = new Date();
		const eventDateUTC = formatLocalDate(item.liveDateTime);
		const eventDateLocal = new Date(eventDateUTC);
		const eventSoonDate = moment(eventDateLocal).subtract(minutesBefore,"minutes").toDate();
		const isBetween = moment(now).isBetween(eventSoonDate,eventDateLocal , 'seconds', "[]");
		const alreadyStarted =  moment(now).isAfter(eventDateLocal)
		const calendarDay = moment(eventDateLocal).calendar(now);

		switch(item.type) {
			case "live":
				return (
					<>
						<div className="live-container__item__header">
							<Link to={item.url}><img src={smallerImage(item.image, "md")} alt={item.altImageTxt} onClick={()=>props.setActive()}/></Link>
						</div>
						<div className="live-container__item__description">
							<Link to={item.categoryURL} className="live-container__item__category" onClick={()=>props.setActive()}>{item.category}</Link> 
							<Link to={item.url} className="live-container__item__title" onClick={()=>props.setActive()}>{item.title}</Link>
						</div>
						{renderLive()}
					</>
				)
				break;
			case "prelive":
				if(isBetween === false) {
					if (alreadyStarted){
						return (
							<>
								<div className="live-container__item__header">
									<Link to={item.url}><img src={smallerImage(item.image, "md")} alt={item.altImageTxt} onClick={()=>props.setActive()}/></Link>
								</div>
								<div className="live-container__item__description">
									<Link to={item.categoryURL} className="live-container__item__category" onClick={()=>props.setActive()}>{item.category}</Link> 
									<Link to={item.url} className="live-container__item__title" onClick={()=>props.setActive()}>{item.title}</Link>
								</div>
								{renderLive()}
							</>
						)
					}
					else{
						return (
							<>
								<div className="live-container__item__header"> 
									<img src={smallerImage(item.image, "md")} alt={item.altImageTxt} tabIndex="0" className="f-item" />
									<div className="live-container__item__live-info" tabIndex="0">
										<time>{calendarDay}</time>
									</div>
								</div>
								<div className="live-container__item__description">
									<p className="live-container__item__category" tabIndex="0">{item.category}</p> 
									<p className="live-container__item__title" tabIndex="0">{item.title}</p>
								</div>
							</>
						)
					}
				} else {
					return (
						<>
							<div className="live-container__item__header"> 
								<Link to={item.url} onClick={()=>props.setActive(false)}><img src={smallerImage(item.image, "md")} alt={item.altImageTxt} className="f-item"/></Link>
								<div className="live-container__item__live-info">
									{getLabel("LIVE")}<Moment interval={1000} date={eventDateLocal} fromNow/>
								</div>
							</div>
							<div className="live-container__item__description">
								<Link to={item.categoryURL} className="live-container__item__category" onClick={()=>props.setActive(false)}>{item.category}</Link> 
								<Link to={item.url} className="live-container__item__title" onClick={()=>props.setActive(false)}>{item.title}</Link>
							</div>
						</>
					)
				}
				break;
			case "cpactv":
				return (
					<>
						<div className="live-container__item__header"> 
							<Link to={item.url} onClick={()=>props.setActive(false)}><img src={smallerImage(item.image, "md")} alt={item.altImageTxt}/></Link>
						</div>
						<div className="live-container__item__description">
							<Link to={item.categoryURL} className="live-container__item__category" onClick={()=>props.setActive(false)}>{item.category}</Link> 
							<Link to={item.url} className="live-container__item__title" onClick={()=>props.setActive(false)}>{item.title}</Link>
						</div>
						{renderCpactv()}
					</>
				)
				break;
			default:
				return (
					<>
						<div className="live-container__item__header"> 
							<Link to={item.url}><img src={smallerImage(item.image, "md")} alt={item.altImageTxt} onClick={()=>props.setActive()}/></Link>
						</div>
						<div className="live-container__item__description">
							<Link to={item.categoryURL} className="live-container__item__category" onClick={()=>props.setActive()}>{item.category}</Link> 
							<Link to={item.url} className="live-container__item__title" onClick={()=>props.setActive()}>{item.title}</Link>
						</div>
					</>
				)
		}
	}

	const renderLive = () => {
		return (
			<div className="video-live-label t-l">
				<img src="/static-assets/theme/svg/target.svg" alt="target-icon"/>
				<span>{getLabel("LIVE")}</span>
			</div>
		)
	}

	const renderCpactv = () => {
		return (
			<div className="live-container__item__cpactv">
				<img src="/static-assets/theme/svg/left-decoration.svg" alt="left-decoration"/>
				<span>CPAC TV</span>
			</div>
		)
	}

	const renderItems = () => {
		return props.livestreams.map((item,i) => {
			return (
				<li key={i} className={`live-container__item ${active ? '' : 'hidden'}`}>
					{renderSmallItemInfo(item)}
				</li>
			);
		}); 
	}

	return (
		<LiveBarHolder>
			<section
				className={`live-bar ${active ? 'expandDown-appear' : 'expandDown-collapse'} ${delayAnim ? "hidden" : ""}`}
				aria-hidden={active ? false : true}
				tabIndex={active ? 0 : -1}
				ref={ liveContainer }
				aria-label={active ? getLabel("LIVE") : undefined}>
				<ul className="live-container" ref={modalRef}>
					{props && props.livestreams && props.livestreams.length > 0 && renderItems()}
				</ul>
			</section>
		</LiveBarHolder>
	)
}

export default LiveBar;
